import { attachmentInfoBarMessageIds } from './AttachmentInfoBarMessageId';

export default function clearAttachmentInfoBarMessages(
    infoBarRemoveHandler: (infoBarMessageIds: string[]) => void
) {
    if (infoBarRemoveHandler) {
        infoBarRemoveHandler(attachmentInfoBarMessageIds);
    }
}
